import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPblCvAuthorisation } from '@/api/pbl.api';
import { Button } from '@/components/UI/Button';
import { errorHandler } from '@/utils/toastHandler';

export default function CvAuthorisationDownload({
  profileId,
  revisionId,
  fileName,
}: {
  profileId: number;
  revisionId?: number;
  fileName?: string | null;
}) {
  // @ts-ignore -- legacy translation catalog exceeds recursive key inference.
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const response = await getPblCvAuthorisation(profileId, revisionId);
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || 'firm-authorisation.pdf';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      errorHandler(t('pbl.cvRevisionUpdate.downloadFailed' as any));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button type="button" size="md" variant="primary-invert" disabled={busy} onClick={download}>
      {t('pbl.cvRevisionUpdate.downloadAuthorisation' as any)}
      {fileName ? `: ${fileName}` : ''}
    </Button>
  );
}
